<template>
  <div class="input-tag-number-field">
    <div class="input-tag-number-field__control">
      <PInput
        :model-value="draft"
        :label="campo.label"
        :required="campo.obrigatorio"
        :error="Boolean(error)"
        :placeholder="campo.placeholder ?? ''"
        full
        class="input-tag-number-field__input"
        @update:model-value="onInput"
        @keydown.enter.prevent="addValue"
      />
      <!-- TODO[FINC-1624]: substituir botão nativo por input com ação do Prisma. -->
      <button
        type="button"
        class="input-tag-number-field__add"
        :disabled="isAddDisabled"
        aria-label="Adicionar"
        @click="addValue"
      >
        <PMaterialIcon icon="add" size="20px" />
      </button>
    </div>

    <!-- TODO[FINC-1624]: substituir el-tag por tag/chip do Prisma. -->
    <div v-if="values.length" class="input-tag-number-field__tags">
      <el-tag
        v-for="(value, index) in values"
        :key="`${value}-${index}`"
        closable
        disable-transitions
        @close="removeValue(index)"
      >
        {{ value }}
      </el-tag>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PInput, PMaterialIcon } from "@f360-dev/f360-prisma";
import { computed, ref } from "vue";
import { TIntegracaoCampoModel } from "../../../@types/IntegracaoCampoModel";
import { ETipoVisualizacao } from "../../../@types/IntegracaoCampoEnum";

const props = defineProps<{
  campo: TIntegracaoCampoModel;
  modelValue?: string[];
  error?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string[]): void;
}>();

const draft = ref("");

const acceptsOnlyNumbers = computed(
  () => props.campo.tipoVisualizacao === ETipoVisualizacao.INPUT_TAG_NUMBER
);

const values = computed<string[]>(() =>
  Array.isArray(props.modelValue) ? props.modelValue : []
);

const canAdd = computed(() => {
  const trimmed = draft.value.trim();

  return trimmed.length > 0 && !values.value.includes(trimmed);
});

const isAddDisabled = computed(() => !canAdd.value);

const onInput = (value: string) => {
  const texto = String(value ?? "");
  draft.value = acceptsOnlyNumbers.value ? texto.replace(/\D/g, "") : texto;
};

const addValue = () => {
  if (!canAdd.value) return;
  emit("update:modelValue", [...values.value, draft.value.trim()]);
  draft.value = "";
};

const removeValue = (index: number) => {
  emit(
    "update:modelValue",
    values.value.filter((_, current) => current !== index)
  );
};
</script>

<style scoped lang="scss">
.input-tag-number-field {
  width: 100%;

  &__control {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: end;
    gap: 8px;
    width: 100%;
  }

  &__input {
    min-width: 0;
    width: 100%;

    :deep(> *),
    :deep(.p-input),
    :deep(.p-input__wrapper) {
      width: 100%;
    }
  }

  &__add {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    border-radius: 5px;
    background-color: #0055ff;
    color: #fff;
    cursor: pointer;

    &:hover {
      background-color: #0044cc;
    }

    &:disabled {
      background-color: #c5d3f0;
      cursor: not-allowed;
    }
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
  }
}
</style>
